import { IoCalendarOutline } from "react-icons/io5";
import { UserContext } from "../context/UserContext";
import { useContext, useEffect, useState } from "react";
import { base_url } from '../url_variables';
import axios from 'axios';
import { useCookies } from "react-cookie";
import { GridLoader } from "react-spinners";

export default function SectionActivities() {
    const {userProfile, logOutFunction} = useContext(UserContext);
    const [cookies] = useCookies();
    const [sections, setSections] = useState([]);

    const [pageLoading, setPageLoading] = useState(true);

    useEffect(() => {
        console.log('cook', cookies);
        getData();
    }, [])

    async function getData() {
        setPageLoading(true)
        try {
            const response = await axios.get(base_url + '/sections.php', {
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: cookies?.userProfile?.session,
                    memberno: cookies?.userProfile?.main_id,
                },
            });
            if (response.data.code == 403) {
                logOutFunction()
            }
            if (response.data.status) {
                setSections(response.data.data.member_sections);
            } else {

            }
            setPageLoading(false)
        } catch (error) {
            setPageLoading(false)
        }
    }

    return (
        <div className="p-6 h-[-webkit-fill-available]">
        {pageLoading && (
        <div className="flex items-center justify-center h-full w-[-webkit-fill-available] z-[99] bg-[#ffffff] fixed opacity-[0.9]">
            <GridLoader
                color={'#037684'}
                loading={true}
                size={20}
                aria-label="Loading Spinner"
                data-testid="loader"
            />
        </div>
        )}
        <h2 className="text-2xl text-[#037684] font-bold mb-6">My Sections</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {sections.map((section) => (
                <div key={section.id} className="rounded-[7px] border border-1 hover:cursor-pointer transition">
                    <div className="flex flex-col items-center space-y-2 pt-3">
                        <h3 className="text-lg font-semibold">{section.name}</h3>
                    </div>
                    <div className="text-center space-y-3 pb-4">
                    <div className="flex items-center justify-center gap-2 text-gray-700">
                        <span className="font-medium">{section.section_fee}</span>
                    </div>
                    <div className="flex flex-col items-center justify-center text-gray-700">
                        <span className="font-medium">Captains</span>
                        <span className="font-regular text-sm">{section.captains}</span>
                    </div>
                    <div className="flex items-center justify-center gap-2 text-gray-700">
                        <IoCalendarOutline className="w-4 h-4 text-red-600" />
                        <span className="text-sm">Next Due: {section.renewal_date}</span>
                    </div>
                    </div>
                </div>
            ))}
        </div>
        {sections?.length < 1 && (
            <div className="w-full h-[-webkit-fill-available] flex items-center justify-center">
            <div className="rounded-[7px]">
                <div className="flex flex-col items-center">
                    <h3 className="text-lg font-semibold">{'No Sections Joined'}</h3>
                    <span className="text-sm">Contact membership office</span>
                </div>
            </div>
            </div>
        )}
        </div>
    )
}
